import { statisticsConfig } from '@/utils/statisticsConfig'



export const staticType = {
    'proinfo':{
        check:()=> {statisticsConfig.insur_proinfo_clause_check_click()},
        uncheck:()=> {statisticsConfig.insur_proinfo_clause_uncheck_click()},
        treatyshow:()=> {statisticsConfig.insur_proinfo_clause_click()},
    },
    'insurinfoinput':{
        check:()=> {statisticsConfig.insur_insurinfoinput_clause_check_click()},
        uncheck:()=> {statisticsConfig.insur_insurinfoinput_clause_uncheck_click()},
        treatyshow:()=> {statisticsConfig.insur_insurinfoinput_clause_click()},
    }
}